import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/call-intel-trial-product-teaser.png';

const thumbHashString = 'XxaBBQAjKXbNJmgMUdB5CK2HWFWHaYCZlw==';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 1;
const originalWidth = 120;

const CallIntelTrialProductTeaser = ({
  aspectRatio = calculatedAspectRatio,
  width = originalWidth,
  ...rest
}: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default CallIntelTrialProductTeaser;
